var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { customEvent } from '@assets/utils/customEvent';
import { getSession } from '@embed/store/session';
export { EventError, EventType } from '@assets/utils/customEvent';
export const customEmbedEvent = ({ type, params, data = {}, videoElement, }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    if (!params) {
        return;
    }
    const { app_id, channel, hashtag, name, playlist, target, widget_id } = params;
    const { session: { guest_id } = { guest_id: null } } = yield getSession();
    // TODO better way of sanitizing
    // if fields need their own sanitization functions, this could become an array of objects
    // with a field for the key and an arrow function to sanitize
    if ((_a = data === null || data === void 0 ? void 0 : data.video) === null || _a === void 0 ? void 0 : _a.encoded_id) {
        const partialFields = [
            'encoded_id',
            'badge',
            'caption',
            'hashtags',
            'video_type',
            'live_stream_status',
        ];
        const video = partialFields.reduce((previousValue, currentValue) => {
            var _a;
            previousValue[currentValue] = (_a = data.video) === null || _a === void 0 ? void 0 : _a[currentValue];
            return previousValue;
        }, {});
        data['video'] = video;
    }
    if (videoElement) {
        data['extra'] = Object.assign(Object.assign({}, (data['extra'] || {})), { duration: videoElement.duration, height: videoElement.height, progress: videoElement.currentTime, width: videoElement.width });
    }
    customEvent({
        target,
        type,
        data: Object.assign({ app_id,
            channel,
            guest_id,
            hashtag,
            name,
            playlist,
            widget_id }, data),
    });
});
